// src/lib/firebase.ts
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAnalytics, isSupported as analyticsSupported, setConsent } from "firebase/analytics";
// NOTE: don't import isSupported from performance – not in your version
import { getPerformance } from "firebase/performance";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(config);

if (import.meta.env.VITE_APPCHECK_PUBLIC_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(import.meta.env.VITE_APPCHECK_PUBLIC_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

setConsent({
  ad_storage: "denied",
  analytics_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
});

export const enableAnalytics = async () => {
  if (await analyticsSupported()) getAnalytics(app);

  // Guarded Performance init (no isSupported in your version)
  if (typeof window !== "undefined" && "performance" in window) {
    try {
      getPerformance(app);
    } catch {
      /* ignore */
    }
  }
};
